export default __webpack_public_path__ + "static/media/Left.cbf2539e.svg";